// ─── Login security: devices, log out everywhere, allowlist, login log ──────
// Owner, 2026-10-21. Worker routes/loginSecurity.ts, migration 261. A file of
// its own, like lib/chatPrefsApi.ts, so parallel work on lib/api.ts never
// collides with it.
import { apiFetch } from './api';

export interface MySession {
  id: string;
  created_at: string;
  last_used_at: string;
  user_agent: string | null;
  ip: string | null;
  current: boolean;
}

export interface TeamAccessRow {
  email: string;
  kind: 'person' | 'service';
  role: 'admin' | 'staff';
  note: string | null;
  added_by: string | null;
  added_at: string;
  name: string | null;
  has_account: boolean;
}

export interface LoginEvent {
  id: number;
  at: string;
  email: string | null;
  method: string | null;
  result: string;
  reason: string | null;
  ip: string | null;
  user_agent: string | null;
}

export const loginSecurityApi = {
  sessions: () => apiFetch<{ sessions: MySession[]; max_days: number }>('/auth-security/sessions'),
  logoutAll: () => apiFetch<{ ok: boolean; revoked: number }>('/auth-security/sessions/logout-all', { method: 'POST' }),
  logoutOne: (id: string) =>
    apiFetch<{ ok: boolean; revoked: number }>(`/auth-security/sessions/${encodeURIComponent(id)}`, { method: 'DELETE' }),
  team: () =>
    apiFetch<{ password_login_enabled: boolean; me: string; team: TeamAccessRow[] }>('/auth-security/team'),
  addEmail: (email: string, role: 'admin' | 'staff') =>
    apiFetch<{ ok: boolean }>('/auth-security/team', { method: 'POST', body: JSON.stringify({ email, role }) }),
  removeEmail: (email: string) =>
    apiFetch<{ ok: boolean }>(`/auth-security/team/${encodeURIComponent(email)}`, { method: 'DELETE' }),
  setPasswordLogin: (enabled: boolean) =>
    apiFetch<{ ok: boolean; enabled: boolean }>('/auth-security/password-login', {
      method: 'PUT', body: JSON.stringify({ enabled }),
    }),
  loginEvents: () => apiFetch<{ events: LoginEvent[] }>('/auth-security/login-events?limit=200'),
};

/** « iPhone · Safari », « Mac · Chrome »… from a browser's user-agent. Pure. */
export function deviceLabel(ua: string | null | undefined): string {
  if (!ua) return 'Appareil inconnu';
  const os = /iPhone/.test(ua) ? 'iPhone'
    : /iPad/.test(ua) ? 'iPad'
    : /Android/.test(ua) ? 'Android'
    : /Macintosh|Mac OS X/.test(ua) ? 'Mac'
    : /Windows/.test(ua) ? 'Windows'
    : /Linux/.test(ua) ? 'Linux'
    : /node|undici|axios|curl/i.test(ua) ? 'Serveur'
    : 'Appareil';
  const browser = /Edg\//.test(ua) ? 'Edge'
    : /CriOS|Chrome\//.test(ua) ? 'Chrome'
    : /FxiOS|Firefox\//.test(ua) ? 'Firefox'
    : /Safari\//.test(ua) ? 'Safari'
    : null;
  return browser ? `${os} · ${browser}` : os;
}
